import React, { useEffect, useState } from 'react';
import { Button } from '../../UI';

import Arrow from '../../../assets/right-arrow.svg';
import BitcoinsIcons from '../../../assets/bitcoins-icons.svg';

import { Container } from './styles';
import Modal from '../';
import Select, { components } from 'react-select';
import { useCashback } from '../../../hooks/cashback';
import CoinIcon from '../../CoinIcon';
import { CircularProgress } from '@mui/material';
import { CustomSelect } from '../../UI/Select/styles';

interface Option {
  value: string;
  label: string;
}

interface Cashback {
  available: string;
  available_formatted: string;
  in_btc: string;
}

interface Props {
  open: boolean;
  onClose: (done?: boolean) => void;
  cashback: Cashback;
}

const Invest: React.FC<Props> = ({ open, onClose, cashback }) => {
  const [currencyEnum, setCurrencyEnum] = useState<Option[]>([]);
  const [selectedCurrency, setSelectedCurrency] = useState<Option>({
    value: 'BTC',
    label: 'BTC',
  });
  const [loadingInvest, setLoadingInvest] = useState(false);
  const [isFinished, setIsFinished] = useState(false);

  const { getCurrencyEnum, createExchangeRequest } = useCashback();

  useEffect(() => {
    async function getCurrencyEnumData() {
      try {
        const response = await getCurrencyEnum();
        setCurrencyEnum(
          response.map(currency => ({ value: currency, label: currency }))
        );
      } catch (error) {
        console.log(error);
      }
    }

    getCurrencyEnumData();
  }, []);

  const { Option } = components;

  const IconOption = props => (
    <Option {...props}>
      <CoinIcon name={props.data.value} />
      {props.data.label}
    </Option>
  );

  const selectStyles = {
    container: provided => ({
      ...provided,
      width: '100%',
    }),
    control: provided => ({
      ...provided,
      border: 'none',
      boxShadow: 'none',
    }),
    option: provided => ({
      ...provided,
      display: 'flex',
      alignItems: 'center',
    }),
    menu: provided => ({
      ...provided,
      width: 'calc(100% + 30px)',
      marginLeft: -30,
    }),
    menuList: provided => ({
      ...provided,
      maxHeight: 180,
      overflow: 'auto',
    }),
  };

  const handleInvest = async () => {
    try {
      setLoadingInvest(true);
      await createExchangeRequest({
        currency_from: 'BRL',
        currency_to: selectedCurrency.value,
        amount_from: cashback.available,
      });
      setLoadingInvest(false);
      setIsFinished(true);
    } catch (error) {
      setLoadingInvest(false);
      console.log(error);
    }
  };

  return (
    <Modal open={open} onClose={() => onClose(isFinished)}>
      <Container>
        <h1 className="title">Troca de criptoback</h1>
        {!isFinished ? (
          <div className="invest">
            <h1 className="description">
              Para qual cripto
              <br /> você quer converter?
            </h1>
            <div className="content">
              <div className="inputGroup">
                <div className="currency">
                  <div className="currencyInput">
                    <CoinIcon name="BRL" />
                    <span>BRL Real</span>
                  </div>
                  <span className="description">
                    Criptoback disponível {cashback.available_formatted}
                  </span>
                </div>
                <div className="arrow">
                  <Arrow />
                </div>
                <div className="targetCurrency">
                  <div className="targetCurrencySelect">
                    <div className="alignIcon">
                      <CoinIcon name={selectedCurrency.value} noMargin />
                    </div>
                    <CustomSelect
                      defaultValue={selectedCurrency}
                      options={currencyEnum}
                      components={{
                        IndicatorSeparator: () => null,
                        Option: IconOption,
                      }}
                      onChange={value => setSelectedCurrency(value as any)}
                      styles={selectStyles}
                    />
                  </div>
                  <span className="description">Criptoback convertido</span>
                  <span className="currentCashback">{cashback.in_btc}</span>
                </div>
              </div>
            </div>
            <Button
              disabled={Number(cashback.available) <= 0}
              className="investButton"
              onClick={handleInvest}
            >
              {loadingInvest ? (
                <CircularProgress size={24} className="loading" />
              ) : (
                'Quero converter meu criptoback'
              )}
            </Button>
          </div>
        ) : (
          <div className="investSuccess">
            <div className="content">
              <div className="left">
                <h1 className="subtitle">
                  Parabéns, seu criptoback em "Bitcoin" estará disponível em
                  breve.
                </h1>
                <span className="description">
                  Agora é com a gente, seu cashback em cripto foi escolhido e,
                  assim que estiver disponível, você será avisado!
                </span>
                <Button onClick={() => onClose(isFinished)}>
                  Ir para o meu cashback
                </Button>
              </div>
              <div className="right">
                <BitcoinsIcons />
              </div>
            </div>
          </div>
        )}
      </Container>
    </Modal>
  );
};

export default Invest;
